import React from 'react';
import { useTranslation } from 'react-i18next';

const H = ({ tag: Tag = 'p', html, className }) => (
  <Tag className={className} dangerouslySetInnerHTML={{ __html: html }} />
);
const LI = ({ html }) => <li dangerouslySetInnerHTML={{ __html: html }} />;

const PrivacyPolicy = () => {
  const { t } = useTranslation();

  return (
    <div className="legal-page">
      <div className="top-bar" />
      <div className="legal-container">
        <h1 className="legal-title">{t('privacy.title')}</h1>
        <p className="legal-update">{t('legal.lastUpdate')}: {t('legal.date')}</p>

        <section className="legal-section">
          <H html={t('privacy.intro')} />
        </section>

        <section className="legal-section">
          <h2>{t('privacy.s1t')}</h2>
          <H html={t('privacy.s1p')} />
          <ul>
            <LI html={t('privacy.s1l1')} />
            <LI html={t('privacy.s1l2')} />
          </ul>
          <p className="legal-note"><em>{t('privacy.s1note')}</em></p>
        </section>

        <section className="legal-section">
          <h2>{t('privacy.s2t')}</h2>
          <H html={t('privacy.s2intro')} />
          <ul>
            <LI html={t('privacy.s2l1')} />
            <LI html={t('privacy.s2l2')} />
            <LI html={t('privacy.s2l3')} />
          </ul>
        </section>

        <section className="legal-section">
          <h2>{t('privacy.s3t')}</h2>
          <H html={t('privacy.s3intro')} />
          <ul>
            <LI html={t('privacy.s3l1')} />
            <LI html={t('privacy.s3l2')} />
            <LI html={t('privacy.s3l3')} />
            <LI html={t('privacy.s3l4')} />
          </ul>
        </section>

        <section className="legal-section">
          <h2>{t('privacy.s4t')}</h2>
          <H html={t('privacy.s4p')} />
        </section>

        <section className="legal-section">
          <h2>{t('privacy.s5t')}</h2>
          <ul>
            <LI html={t('privacy.s5l1')} />
            <LI html={t('privacy.s5l2')} />
            <LI html={t('privacy.s5l3')} />
          </ul>
        </section>

        <section className="legal-section">
          <h2>{t('privacy.s6t')}</h2>
          <H html={t('privacy.s6p1')} />
          <ul>
            <LI html={t('privacy.s6l1')} />
            <LI html={t('privacy.s6l2')} />
          </ul>
          <H html={t('privacy.s6p2')} />
        </section>

        <section className="legal-section">
          <h2>{t('privacy.s7t')}</h2>
          <H html={t('privacy.s7intro')} />
          <ul>
            <LI html={t('privacy.s7l1')} />
            <LI html={t('privacy.s7l2')} />
            <LI html={t('privacy.s7l3')} />
            <LI html={t('privacy.s7l4')} />
            <LI html={t('privacy.s7l5')} />
            <LI html={t('privacy.s7l6')} />
            <LI html={t('privacy.s7l7')} />
          </ul>
          <H html={t('privacy.s7p')} />
        </section>

        <section className="legal-section">
          <h2>{t('privacy.s8t')}</h2>
          <H html={t('privacy.s8p')} />
        </section>

        <section className="legal-section">
          <h2>{t('privacy.s9t')}</h2>
          <H html={t('privacy.s9p')} />
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
